import React from 'react';
import Entry from '../entry';
import { Flex, Text } from 'rebass';
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

export default () => {
  const title = '4. Windows Log Analysis: Determine Attacker Technique';
  const flag = 'ntdsutil';
  const hints = [
    (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[SugarPlum Mary] </Text><a rel="noopener noreferrer" target="_blank" href='https://www.darkoperator.com/blog/2014/8/8/sysinternals-sysmon'>Sysmon</a></Flex>),
   (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[SugarPlum Mary] </Text><a rel="noopener noreferrer" target="_blank" href='https://pen-testing.sans.org/blog/2019/12/10/eql-threat-hunting/'>EQL Threat Hunting</a></Flex>),
 (<Flex flexDirection='row' flexWrap='wrap'><Text mr={2}>[SugarPlum Mary Chat] </Text><a rel="noopener noreferrer" target="_blank" href='https://www.endgame.com/our-experts/ross-wolf'>Ross Wolf blog</a></Flex>)];

  const assignment = 'Using these normalized Sysmon logs, identify the tool the attacker used to retrieve domain password hashes from the lsass.exe process. For hints on achieving this objective, please visit Hermey Hall and talk with SugarPlum Mary.'
  const data = useStaticQuery(graphql`
    query {
      lsass: file(relativePath: { eq: "lsass.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      childLsass: file(relativePath: { eq: "childLsass.png" }) {
        childImageSharp {
          fluid(maxWidth: 350) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code4_1: file(relativePath: { eq: "code4_1.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      code4_2: file(relativePath: { eq: "code4_2.png" }) {
        childImageSharp {
          fluid(maxWidth: 400) {
            ...GatsbyImageSharpFluid
          }
        }
      }


    }
  `)

  return (
    <Entry
      title={title}
      hints={hints}
      flag={flag}
      assignment={assignment}
    >
      <Text my={2}>EQL is nice, but JavaScript is great at parsing JSON. Let's look for traces of 'lsass' in logs</Text>
      <Img fluid={data.code4_1.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>The code above prints the following: </Text>
      <Img fluid={data.lsass.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '55vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />

      <Text my={2}>The only mention of 'lsass' is that it created a 'cmd' process. Let's track what happens to that 'cmd' process</Text>
      <Img fluid={data.code4_2.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '26vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>Which results in: </Text>
      <Img fluid={data.childLsass.childImageSharp.fluid}
              style={{ margin: 0,  maxHeight: '60vh', width: '70vw' }}
              imgStyle={{ objectFit: 'contain' }}
      />
      <Text my={2}>The EQL Threat Hunting blog helps us verify that "ntsdutil", "ifm" and "create" on command line are used to create an accessible backup of the domain password hashes </Text>
    </Entry>
  )

};
